import { pageLayout_children } from "materials/pageLayout/menus/index.js"

export default {
  name: "头部",
  id: "",
  thumbnail: "icon-portal-menu_header",
  type: "cxHeader",
  attribute: pageLayout_children[0].attribute
}
